<template>
  <div class="product-page">
    <main id="main-content">
      <CloudGamingHeroSection />
      <CloudGamingFeaturesSection />
      <CloudGamingArchitectureSection />
      <CloudGamingBenefitsSection />
      <CloudGamingCloudPhoneSection />
      <CloudGamingAdvantagesSection />
    </main>
  </div>
</template>

<script setup lang="ts">
import CloudGamingAdvantagesSection from '@/components/cloud-gaming/CloudGamingAdvantagesSection.vue';
import CloudGamingArchitectureSection from '@/components/cloud-gaming/CloudGamingArchitectureSection.vue';
import CloudGamingBenefitsSection from '@/components/cloud-gaming/CloudGamingBenefitsSection.vue';
import CloudGamingCloudPhoneSection from '@/components/cloud-gaming/CloudGamingCloudPhoneSection.vue';
import CloudGamingFeaturesSection from '@/components/cloud-gaming/CloudGamingFeaturesSection.vue';
import CloudGamingHeroSection from '@/components/cloud-gaming/CloudGamingHeroSection.vue';
import { useSeo } from '@/composables/useSeo';
import '@/styles/newhome/product-page.css';

useSeo({
  title: '海曦云游戏解决方案｜芯片到系统全栈优化，低延迟高并发云端游戏、云手机一体化算力服务',
  description:
    '完成芯片到应用全链路技术优化，端到端传输延迟低至5ms，搭建可承载十万级用户的渲染集群、全球50+边缘节点，配套多端适配SDK与版权保护能力；可实现两周快速上线、算力弹性伸缩，同步提供云手机方案，已有商用落地案例，依托充足资金保障大规模算力交付。'
});
</script>
